import {
  CLEAR_MESSAGES,
  MESSAGE_CREATE_UPDATE_START,
  MESSAGE_CREATE_UPDATE_SENDING,
  MESSAGE_CREATE_UPDATE_SUCCESS,
  MESSAGE_CREATE_UPDATE_FAILURE,
} from 'app/modules/messages/constants';

/*
 * Reducers
 */

export const byId = (state = {}, action) => {
  switch (action.type) {
    case MESSAGE_CREATE_UPDATE_SENDING:
    case MESSAGE_CREATE_UPDATE_SUCCESS:
    case MESSAGE_CREATE_UPDATE_FAILURE:
      let messageId = action.record.id;
      return {
        ...state,
        [messageId]: singleMessageReducer(state[messageId], action),
      };
    case CLEAR_MESSAGES:
      return {};
    default:
      return state;
  }
};

export const allIds = (state = [], action) => {
  switch (action.type) {
    case MESSAGE_CREATE_UPDATE_SENDING:
    case MESSAGE_CREATE_UPDATE_SUCCESS:
      let messageId = action.record.id; // TBD
      if (state.indexOf(messageId) < 0) {
        return state.concat(messageId);
      }
      return state;
    case CLEAR_MESSAGES:
      return [];

    default:
      return state;
  }
};

function singleMessageReducer(state = {}, action) {
  switch (action.type) {
    case MESSAGE_CREATE_UPDATE_SENDING:
      return { ...action.record, _isSending: true };
    case MESSAGE_CREATE_UPDATE_SUCCESS:
      return action.record;
    case MESSAGE_CREATE_UPDATE_FAILURE:
      return { ...state, _isSending: false, _hasError: true, _errors: action.errors };
    default:
      return state;
  }
}

/*
 * Action creators
 */
export const createMessage = record => ({ type: MESSAGE_CREATE_UPDATE_START, record });
export const createMessageSending = record => ({ type: MESSAGE_CREATE_UPDATE_SENDING, record });
export const clearMessages = () => ({ type: CLEAR_MESSAGES });

export const createOrUpdateMessageSuccess = record => ({ type: MESSAGE_CREATE_UPDATE_SUCCESS, record });
export const createOrUpdateMessageFailure = (id, errors) => ({
  type: MESSAGE_CREATE_UPDATE_FAILURE,
  record: { id },
  errors,
});
